import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../../config';
import Select from 'react-select';
import NdoeSpinner from '../../../components/ndoe/NdoeSpinner';
import { Modal } from 'antd';
import { toast } from 'react-toastify';

const FormPaiement = ({ fetchData, closeModal }) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [getClient, setGetClient] = useState([]);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const handleInputChange = (e) => {
    const fieldName = e.target.name;
    let fieldValue = e.target.value;

    let updatedValue = fieldValue;

    if (fieldName === "contact_email") {
      updatedValue = fieldValue.toLowerCase();
    } else if (Number.isNaN(Number(fieldValue))) {
      if (fieldValue) {
        updatedValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
      }
    }

    setData((prev) => ({ ...prev, [fieldName]: updatedValue }));
  };

  const handleConfirm = async () => {
    if (loading) return;
    try {
      setLoading(true);
      await axios.post(`${DOMAIN}/api/vente/vente/paiement`, data);
      toast.success('Le paiement a été enregistré avec succès!');
      setConfirmVisible(false);
      if (fetchData) fetchData();       // refetch la liste au lieu de recharger la page
      if (closeModal) closeModal();     // ferme la modale d'ajout
    } catch (err) {
      // err.message d'axios vaut « Request failed with status code 400 » : le
      // motif réel (« Commande ou montant de paiement invalide. ») est renvoyé
      // par le serveur, il faut le lire là où il est.
      toast.error(
        err?.response?.data?.error
          || err?.response?.data?.message
          || `Le paiement n'a pas pu être enregistré : ${err.message}`,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Garde explicite : les `required` du formulaire sont inertes (il n'y a pas
    // de <form> natif qui les soumette), et le serveur refuse déjà ces cas —
    // mais autant le dire ici, en français, plutôt que d'ouvrir un récapitulatif
    // « Montant: N/A » puis de renvoyer une erreur.
    if (!data.id_commande) {
      toast.warning('Choisissez la cliente et sa commande.');
      return;
    }
    if (!Number(data.montant) || Number(data.montant) <= 0) {
      toast.warning('Saisissez un montant supérieur à zéro.');
      return;
    }
    setConfirmVisible(true);
  };

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  useEffect(() => {
    const loadClients = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/commande`);
        setGetClient(data);
      } catch (error) {
        console.log(error);
      }
    };

    loadClients();
  }, [DOMAIN]);

  return (
    <>
      <div className="formCatDepense">
        <div className="product-container">
          <div className="product-wrapper">
            <div className="form-controle-desc">
              <label htmlFor="">Client(e)</label>
              <Select
                name="id_commande"
                options={getClient?.map(item => ({ value: item.id_commande, label: `${item.nom}/ commande N°${item.id_commande}`}))}
                onChange={selectedOption => {
                  const selectedIdCommande = selectedOption.value;
                  const selectedIdClient = getClient.find(item => item.id_commande === selectedIdCommande)?.id_client;
                  handleInputChange({ target: { name: 'id_commande', value: selectedIdCommande } });
                  handleInputChange({ target: { name: 'id_client', value: selectedIdClient } });
                }}
              />
            </div>
            <div className="form-controle-desc">
              <label htmlFor="">Montant</label>
              <input type="number" name='montant' style={{padding:'8px 10px', border:'1px solid #c5c5c5', outline:'none', borderRadius:'5px'}} min={0} onChange={handleInputChange} />
            </div>
            <div className="form-submit">
              <button className="btn-submit" onClick={handleSubmit}>Envoyer</button>
              <button className="btn-submit btn-annuler" onClick={() => (closeModal ? closeModal() : window.location.reload())}>Annuler</button>
              {loading && (
                <div className="loader-container loader-container-center">
                  <NdoeSpinner size={30} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Confirmer le paiement"
        open={confirmVisible}
        onOk={handleConfirm}
        onCancel={handleCancel}
        /* Sans ça, « Confirmer » restait cliquable pendant tout l'aller-retour
           serveur : en 3G, rien ne bouge après le clic et on retape. Le serveur
           rejette un paiement supérieur au restant dû (venteCtrl.js), donc un
           solde ne peut pas partir deux fois — mais deux acomptes partiels, si. */
        confirmLoading={loading}
        cancelButtonProps={{ disabled: loading }}
        maskClosable={!loading}
        okText="Confirmer"
        cancelText="Annuler"
        className="confirmation-modal"
      >
        <p className="modal-text">Êtes-vous sûr de vouloir soumettre ce paiement avec les informations suivantes ?</p>
        <ul className="modal-data">
          <li>Client: {getClient.find(item => item.id_commande === data.id_commande)?.nom || 'N/A'}</li>
          <li>Commande N°: {data.id_commande || 'N/A'}</li>
          {/* Le garde-fou était `{`${data.montant} $` || 'N/A'}` : un gabarit de
              chaîne est TOUJOURS non vide, donc toujours vrai — la branche
              'N/A' était inatteignable et l'écran affichait « undefined $ » à
              la secrétaire. Faute de placement des accents graves, pas
              d'intention : la ligne du dessus, elle, est correcte. */}
          <li>Montant: {data.montant ? `${data.montant} $` : 'N/A'}</li>
        </ul>
      </Modal>
    </>
  );
};

export default FormPaiement;
